export default __webpack_public_path__ + "static/media/shopee.6b108edc.png";